import { configureStore } from '@reduxjs/toolkit';
import deviceSlice from './slices/deviceSlice';
import alertSlice from './slices/alertSlice';

export const store = configureStore({
  reducer: {
    devices: deviceSlice,
    alerts: alertSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;